import axios from "axios";
import dotenv from "dotenv";
dotenv.config();

let apiUrl;
if (process.env.NODE_ENV === "production") {
  apiUrl = `${process.env.REACT_APP_SITE_URL}`;
} else {
  apiUrl = `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_PORT}`;
}
export const searchRegisterAPI = {
  searchRegister: async (type, value) => {
    try {
      const res = await axios.get(
        `${apiUrl}${process.env.REACT_APP_CHECK_BLACKLIST_ENDPOINT}${process.env.REACT_APP_CHECK_BLACKLIST_CODE}`,
        {
          params: {
            type: type,
            value: value,
          },
          timeout: 60000,
        }
      );
      console.log(res);
      return res;
    } catch (error) {
      if (error.response.status === "401") {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        window.location.href = "/Unauthorized";
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
      throw error;
    }
  },
};
